//@ts-ignore
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";

const WizardList = (props: any) => {
  const { handleToggle } = props;
  const defaultColumns: any = [
    {
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Submission Limit",
      accessorKey: "submission_limit",
      cell: NACell,
    },
    {
      header: "Admin Notifications",
      accessorKey: "is_admin_notification",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_admin_notification")
          }
        />
      ),
    },
    {
      header: "Comment",
      accessorKey: "is_allow_comment",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_allow_comment")
          }
        />
      ),
    },
    {
      header: "SMS",
      accessorKey: "is_sms",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_sms")
          }
        />
      ),
    },
    {
      header: "Visible",
      accessorKey: "is_visible",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_visible")
          }
        />
      ),
    },
    {
      header: "Email",
      accessorKey: "is_email",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_email")
          }
        />
      ),
    },
    {
      header: "Reply",
      accessorKey: "is_reply",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_reply")
          }
        />
      ),
    },
    {
      header: "Pin",
      accessorKey: "pin",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) => handleToggle(value, id, "pin")}
        />
      ),
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) =>
            handleToggle(value, id, "is_active")
          }
        />
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.FORM}
        queryKey={"wizard"}
        params={{ form_type: "wizard", limit: 10, offset: 0 }}
        columns={defaultColumns}
        tableName={"wizard-table"}
      />
    </>
  );
};
export default WizardList;
